module.exports = __webpack_public_path__ + "img/na-lease-assumptions-screen.7ae03888.png";